import React from 'react';
import { Link } from 'react-router-dom';
import { FiXCircle } from 'react-icons/fi';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full">
        <FiXCircle className="text-red-500 mx-auto h-20 w-20 mb-6" />
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Paiement Annulé ou Échoué</h2>
        <p className="text-gray-600 mb-6">
          Votre paiement n'a pas pu être finalisé ou a été annulé.
          Veuillez réessayer ou contacter le support si le problème persiste.
        </p>
        <div className="flex flex-col space-y-4">
          <Link to="/" className="bg-brand-green hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
            Réessayer le paiement
          </Link>
          <Link to="/dashboard" className="text-brand-blue hover:underline font-bold">
            Retourner au tableau de bord
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;